import { render, staticRenderFns } from "./SatelliteTable.vue?vue&type=template&id=395afe8e&scoped=true&"
import script from "./SatelliteTable.vue?vue&type=script&lang=js&"
export * from "./SatelliteTable.vue?vue&type=script&lang=js&"
import style0 from "./SatelliteTable.vue?vue&type=style&index=0&id=395afe8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395afe8e",
  null
  
)

export default component.exports